import { ChatContext } from "@/Contexts/ChatContext";
import { CoachSidebarDataContext } from "@/Contexts/CoachSidebarDataContext";
import { FollowupTaskContext } from "@/Contexts/FollowupTaskContext";
import { navigateTo } from "@/utils/navigation";
import { SYSTEM_STATUS_PAGE_URL } from "@/utils/useSystemStatus";
import { useContext } from "react";
import { BiSupport } from "react-icons/bi";
import { FaUsers } from "react-icons/fa";
import { GoQuestion } from "react-icons/go";
import { LuActivity, LuHistory, LuSettings } from "react-icons/lu";
import { PiUserCircleDashedFill } from "react-icons/pi";
import {
    logOutNavItem,
    mobileAppNavItem,
    videoTestNavItem,
} from "./sharedNavItems";
import { NavItem } from "./types";

export default function useCoachNavItems(): NavItem[] {
    const { numberOfClientsWithTasks } = useContext(FollowupTaskContext);
    const { unread } = useContext(ChatContext);
    const { potentialClientCount, needs2FASetup } = useContext(
        CoachSidebarDataContext,
    );

    const activeUnreadTotal = Object.values(unread).reduce(
        (total, channel) => total + channel.count,
        0,
    );

    return [
        {
            placement: "bar",
            icon: FaUsers,
            name: "Clients",
            onClick: () => navigateTo(route("coach.clients")),
            routeName: "coach.clients",
            selected: route().current()?.startsWith("coach.clients"),
            badgeNumbers: [activeUnreadTotal, numberOfClientsWithTasks],
        },
        {
            placement: "bar",
            icon: PiUserCircleDashedFill,
            name: "Potential Clients",
            onClick: () => navigateTo(route("coach.potentialClients")),
            routeName: "coach.potentialClients",
            selected: route().current() === "coach.potentialClients",
            badgeNumbers: [potentialClientCount],
        },
        mobileAppNavItem(),
        {
            placement: "menu",
            menuSlot: "beforeOverflow",
            icon: LuSettings,
            name: "Settings",
            onClick: () => navigateTo(route("coach.profile.edit")),
            routeName: "coach.profile.edit",
            selected: route().current() === "coach.profile.edit",
            badgeNumbers: [needs2FASetup ? 1 : 0],
        },
        {
            placement: "menu",
            icon: GoQuestion,
            name: "Coach Guide",
            onClick: () =>
                window.open(import.meta.env.VITE_COACH_GUIDE, "_blank"),
        },
        {
            placement: "menu",
            icon: BiSupport,
            name: "Contact Us",
            onClick: () =>
                window.Intercom
                    ? window.Intercom("show")
                    : window.open(import.meta.env.VITE_COACH_GUIDE, "_blank"),
            selected: route().current() === "contact",
        },
        {
            placement: "menu",
            icon: LuActivity,
            name: "System Status",
            onClick: () => window.open(SYSTEM_STATUS_PAGE_URL, "_blank"),
        },
        {
            placement: "menu",
            icon: LuHistory,
            name: "Video Sessions History",
            onClick: () => navigateTo(route("videoSessionsHistory.index")),
            routeName: "videoSessionsHistory.index",
            selected: route().current() === "videoSessionsHistory.index",
        },
        videoTestNavItem(),
        logOutNavItem(),
    ];
}
